import { useEffect, useRef } from 'react';
import { useApplePaySession } from '../hooks/useApplePaySession';
import './applePay.css';

type ApplePayPaymentButtonProps = {
  isValid?: boolean;
};

export const ApplePayPaymentButton = ({
  isValid = true,
}: ApplePayPaymentButtonProps) => {
  const { createAppleSession } = useApplePaySession();
  const buttonRef = useRef<HTMLElement>(null);
  const createAppleSessionRef = useRef(createAppleSession);
  createAppleSessionRef.current = createAppleSession;
  const isValidRef = useRef(isValid);
  isValidRef.current = isValid;

  useEffect(() => {
    const button = buttonRef.current;
    if (!button) return;

    const handleClick = () => {
      if (isValidRef.current) createAppleSessionRef.current();
    };
    button.addEventListener('click', handleClick);
    return () => button.removeEventListener('click', handleClick);
  }, []);

  return (
    <apple-pay-button
      ref={buttonRef}
      buttonstyle="black"
      type="buy"
      locale="pt-BR"
      data-testid="apple-pay-button"
      aria-disabled={!isValid}
      style={isValid ? undefined : { opacity: 0.4, cursor: 'not-allowed' }}
    />
  );
};
